import { LocationStrategy, HashLocationStrategy, APP_BASE_HREF } from '@angular/common';
import {NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
// NEEDFIX: need replace all deprecated functionality usage
import { HttpClientModule, HttpClientJsonpModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JsonpModule } from '@angular/http';                         // deprecated
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotificationsService, SimpleNotificationsModule } from 'angular2-notifications';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { EvDalModule } from './ev-dal/ev-dal.module';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {APP_CONFIG, AppConfig} from './app.config';
import {AdminComponent} from './admin/admin.component';
import {AdminMenuComponent} from './components/admin-menu/admin-menu.component';
import {MainNavComponent} from './components/main-nav/main-nav.component';
import {SecondaryNavComponent} from './components/secondary-nav/secondary-nav.component';
import {CoachComponent} from './coach/coach.component';
import {CoachMenuComponent} from './components/coach-menu/coach-menu.component';
import {ParentMenuComponent} from './components/parent-menu/parent-menu.component';
import {StudentMenuComponent} from './components/student-menu/student-menu.component';
import {ParentComponent} from './parent/parent.component';
import {StudentComponent} from './student/student.component';
import {AccessDeniedComponent} from './components/access-denied/access-denied.component';
import {IntroductionVideosComponent} from './components/introduction-videos/introduction-videos.component';
import { LoginComponent } from './components/login/login.component';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {RegisterComponent} from './components/register/register.component';
import { SharedModule } from './components/shared/shared.module';
import {DraggableModalModule} from './components/shared/draggable-modal/draggable-modal.module';
import { ResetPasswordComponent } from './components/login/reset-password/reset-password.component';
import { PsatScoreComponent } from './components/test-scores/psat-score-list/psat-score/psat-score.component';
import { PasswordRecoveryComponent } from './components/password-recovery/password-recovery.component';
import { AccountSettingsComponent } from './components/account-settings/account-settings.component';
import { DraggableModalService } from './components/shared/draggable-modal/draggable-modal.service';
import { AuthGuard } from './guards/auth-guard.service';
import { HttpConfigInterceptor } from './interceptor/httpconfig.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
@NgModule({
  declarations: [
    AppComponent,
    MainNavComponent,
    AdminComponent,
    AdminMenuComponent,
    SecondaryNavComponent,
    CoachComponent,
    CoachMenuComponent,
    StudentComponent,
    ParentComponent,
    ParentMenuComponent,
    StudentMenuComponent,
    LoginComponent,
    RegisterComponent,
    IntroductionVideosComponent,
    AccessDeniedComponent,
    PageNotFoundComponent,
    ResetPasswordComponent,
    PsatScoreComponent,
    PasswordRecoveryComponent,
    AccountSettingsComponent,
    ContactUsComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpClientJsonpModule,
    NgMultiSelectDropDownModule.forRoot(),
    SharedModule,
    JsonpModule,        // deprecated
    AppRoutingModule,
    BrowserAnimationsModule,
    SimpleNotificationsModule,
    EvDalModule.forRoot(),
    DraggableModalModule.forRoot(),
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      progressBar: true,
      progressAnimation: 'increasing',
      tapToDismiss: true,
      extendedTimeOut: 3000,

    }) // ToastrModule added
  ],
  providers: [
     NotificationsService,
     AuthGuard,
    { provide: APP_CONFIG, useValue: AppConfig },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }
  ],
  entryComponents: [
    ResetPasswordComponent,
    PsatScoreComponent,
    AccountSettingsComponent
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule {
  constructor(private draggableModalService: DraggableModalService, private modalService: BsModalService) {
    this.draggableModalService.register('account-settings-modal', AccountSettingsComponent, this.modalService);
  }
}
